<template>
  <div class="input-group date-picker">
    <el-time-select
      v-if="noCalendar"
      :name="name"
      v-model="dateValue"
      @change="onChange"
      :placeholder="$i18n.t(`date_time_time_interval_${name}`)"
      :picker-options="pickerOptions"
      :format="getTimeFormat"
      arrow-control="true"
    >
    </el-time-select>
    <el-date-picker
      v-else
      :name="name"
      v-model="dateValue"
      :type="getComponentType"
      @change="onChange"
      :placeholder="$i18n.t(`date_time_interval_${name}`)"
      :picker-options="pickerOptions"
      :format="getDateFormat"
      :value-format="getDateFormat"
    >
    </el-date-picker>
  </div>
</template>

<script>
import { isNull, isEmpty } from 'lodash'
import moment from 'moment'

const TIME_FORMATS = ['time', 'time_interval', 'datetime', 'datetime_interval', 'datetime-local']
const DATE_FORMATS = ['date', 'date_interval', 'datetime', 'datetime_interval']

export default {
  name: 'date-time',
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
    },
    value: {
      type: [String, Number, Date],
      default: () => '',
    },
    interval: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dateValue: '',
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    }
  },
  computed: {
    noCalendar() {
      return !DATE_FORMATS.includes(this.type)
    },
    getComponentType() {
      return this.needTime ? 'datetime' : 'date'
    },
    getValue() {
      if (isNull(this.value) || isEmpty(this.value)) return null
      const format = this.noCalendar ? this.getTimeFormat : this.getDateFormat
      return moment(new Date(this.value)).format(format.replace('dd', 'DD'))
    },
    getTimeFormat() {
      let format = 'HH:mm'
      if (this.$CORE.language.code === 'en-US') {
        format = 'hh:mm A'
      }
      return format
    },
    getDateFormat() {
      let format = ''
      switch (this.$CORE.language.code) {
        case 'en-US': {
          format = 'MM/dd/yyyy'
          break
        }
        case 'hu-HU':
        case 'de-DE': {
          format = 'yyyy-MM-dd'
          break
        }
        default: {
          format = 'yyyy-MM-dd'
          break
        }
      }
      if (this.needTime) {
        format += ` ${this.getTimeFormat}`
      }
      return format
    },
    needTime() {
      return TIME_FORMATS.includes(this.type)
    },
  },
  methods: {
    onChange(selectedDate) {
      selectedDate = isNull(selectedDate)
        ? ''
        : moment(new Date(selectedDate.replace(/-/g, '/'))).format('YYYY-MM-DDTHH:mm')

      const ev = {}
      if (DATE_FORMATS.includes(this.type) || TIME_FORMATS.includes(this.type)) {
        Object.assign(ev, { [this.name]: selectedDate })
      }

      this.$emit('form-item-changed', {
        name: this.name,
        value: selectedDate,
      })
      this.$emit('input', ev)
      this.$emit('change', ev)
    },
  },
  created() {
    this.dateValue = this.getValue
  },
  watch: {
    value: {
      handler() {
        this.dateValue = this.getValue
      },
    },
  },
}
</script>
